import { render, staticRenderFns } from "./selector-remote.vue?vue&type=template&id=4b29a6b0&scoped=true"
import script from "./selector-remote.vue?vue&type=script&lang=js"
export * from "./selector-remote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29a6b0",
  null
  
)

export default component.exports